module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-noft"
  }, [_vm._v("Also by Michele Clark McConnochie")]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_vm._v("The Strange Sagas of Sabrina Summers Saga 1:"), _c('br'), _vm._v("The Uncooperative Flying Carpet")]), _vm._v(" "), _c('p', {
    staticClass: "ch-nof"
  }, [_vm._v("And coming soon:")]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_vm._v("The Strange Sagas of Sabrina Summers Saga 3:"), _c('br'), _vm._v("The Uncontrollable Slingshot")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 69
// module chunks = 0